"use client";

import { createAuthRefresh, createClient } from "@workspace/network";

/**
 * Auth FE origin. Injected per stage by `build-stage.ts`; the literal is the
 * local fallback and must stay last. Before tdd-0093 this was hardcoded with
 * no env read at all, so a 401 in prod bounced the user to the local auth app.
 */
const AUTH_APP_URL = process.env.NEXT_PUBLIC_AUTH_URL || "https://auth.l.gaz.codes";

// =============================================================================
// docs network client.
//
// Uses @workspace/network's createClient with 401 → refresh-and-retry built
// in. createClient also queues concurrent requests during a single refresh
// so we don't fire N parallel /v1/refresh calls when the page loads several
// resources at once.
//
// Difference from the canonical sheets pattern: docs has a UX expectation
// that an unrecoverable auth failure bounces the user to the auth login
// screen with a return_to back to the current page. We wrap createAuthRefresh
// so a `false` refresh outcome triggers that redirect before bubbling up.
// =============================================================================

const refreshToken = createAuthRefresh();

async function onUnauthorized(): Promise<boolean> {
  const ok = await refreshToken();
  if (!ok && typeof window !== "undefined") {
    window.location.href = `${AUTH_APP_URL}/login?return_to=${encodeURIComponent(
      window.location.href,
    )}`;
  }
  return ok;
}

export const apiClient = createClient({
  baseUrl: "",
  credentials: "include",
  auth: { onUnauthorized },
});
